import React from "react";
import classNames from "classnames/bind";

import styles from "./SearchDropDown.module.scss";

// components
import EventItem from "./EventItem";

const cx = classNames.bind(styles);

const SearchDropDown = ({ isOpen, data }) => {
  return (
    <React.Fragment>
      {isOpen && (
        <div className={cx("search-drop-down-root")}>
          {data && data.length > 0 ? (
            data.map((item, i) => <EventItem key={i} data={item} />)
          ) : (
            <p className={cx("no-found")}>Nothing Found</p>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default SearchDropDown;
